"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
var CloseButton_1 = require("../../../atoms/CloseButton/CloseButton");
var height = 64;
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    root: {
        height: height,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        flex: '0 0 auto',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    title: {
        marginLeft: 40,
        marginRight: 8,
    },
    closeButton: {
        marginLeft: 24,
        marginRight: 24,
    },
    collapsed: {
        '& $title': {
            marginLeft: 24,
            marginTop: (height - 16) / 2,
            marginBottom: (height - 16) / 2, // center vertically without using alignItems, which cannot be animated
        },
        '& $closeButton': {
            // center vertically without using alignItems, which cannot be animated
            marginBottom: (height - CloseButton_1.smallCloseButtonSize) / 2,
        },
    },
    actions: {
        marginLeft: 24,
        paddingRight: 40,
        display: 'flex',
        transition: theme_1.default.transitions.easeOutFast,
    },
    actionsScrolled: {
        height: '100%',
        alignItems: 'center',
        paddingRight: 24,
    },
    buttonMargin: {
        marginRight: 12,
    },
}));
